import { Component } from '@angular/core';

@Component({
  selector: 'fast-ui-case-card-mock',
  templateUrl: './case-card.component.mock.html',
  styleUrls: ['../case-card.component.scss', './case-card.component.mock.scss', '../case-card.media.scss'],
})
export class CaseCardMockComponent {
}
